<template>
  <section class="block-caution-text">
    <p class="block-caution-text__label">【ご注意】</p>
    <ul class="block-caution-text__list">
      <li class="block-caution-text__item">
        <p class="block-caution-text__text --primary">データ更新のタイミングにより、検索されたプランがない場合や、料金・プランの内容が変更されている場合がございます。</p>
        <p class="block-caution-text__text --secondary">プランが表示されていても、既にプランの販売が中止されている場合は、詳細ページに遷移できないことがございます。</p>
      </li>
      <li class="block-caution-text__item">
        <p class="block-caution-text__text --primary">検索時に表示される料金と予約時に表示される料金が異なる場合がございます。予約時に表示される内容が正しい情報となりますので、予めご了承ください。</p>
        <p class="block-caution-text__text --secondary">サービス料や人数計算方法が通常と異なる場合</p>
        <p class="block-caution-text__text --secondary">ルームチャージ料金の場合</p>
      </li>
      <li class="block-caution-text__item">
        <p class="block-caution-text__text --primary">こだわり条件で検索して表示されるプランで販売されている客室が条件に該当しない場合もございます。</p>
        <p class="block-caution-text__text">プラン詳細、お部屋の詳細をご確認いただき、記載がない場合は、詳細は現地へお問合わせください。</p>
        <p class="block-caution-text__text --secondary">ペット対応客室、バリアフリー対応客室の有無&ensp;&ensp;など</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'BlockCautionText'
}
</script>

<style lang="scss" scoped>
@mixin sp {
  @media screen and (max-width: 639px) {
    @content;
  }
};

.block-caution-text {
  margin-bottom: 2rem;
  padding: 0;

  &__label {
    font-size: 1rem;
    margin-bottom: .5rem;

    @include sp {
      font-size: .875rem;
    }
  }

  &__list {
    padding-bottom: .5rem;
  }

  &__item {
    margin-bottom: .5rem;
  }

  &__text {
    font-size: .875rem;
    line-height: 1.4;
    padding-left: 1rem;
    position: relative;

    @include sp {
      font-size: .75rem;
    }

    &::before {
      left: 0;
      position: absolute;
      top: auto;
    }

    &.--primary::before {
      content: '※';
    }

    &.--secondary::before {
      content: '・';
    }
  }
}
</style>